// extracted by mini-css-extract-plugin
export default {"section":"Pq-z","sectionTitle":"Qq-z","fieldWrapper":"Rq-z","formField":"Sq-z","disabled":"Tq-z","formLabel":"Uq-z"};